export const demoStatusMap = [
    {
      label: 'PCR',
      value: '是-PCR'
    },
    {
      label: '菌液',
      value: '是-A'
    },
    {
      label: '质粒',
      value: '是-B'
    },
    {
      label: '平板',
      value: '是-C'
    },
    {
      label: '菌液/质粒',
      value: '是-A/B'
    },
    {
      label: '质粒/平板',
      value: '是-B/C'
    },
    {
      label: '菌液/平板',
      value: '是-A/C'
    },
    {
      label: '菌液/质粒/平板',
      value: '是-A/B/C'
    }
]

//测序订单详情-返样-默认值处理
export function returnExampleFn(demo) {
  //注：同一个样品，不会既经历滚环，又经历扩增
  //appraisalRollingRingFlag：滚环   appraisalAmplificationFlag：扩增
  const { appraisalRollingRingFlag, appraisalAmplificationFlag } = demo;
  const obj = {
    list: [],
    tips: "",
    defaultValue: ""
  }
  switch (demo.type) { 
    case 'A':
      if (!appraisalRollingRingFlag && !appraisalAmplificationFlag) {
        obj.defaultValue = "是-A";
        obj.list = demoStatusMap;
        obj.tips = "";
      }
      if (appraisalRollingRingFlag || appraisalAmplificationFlag) {
        obj.defaultValue = "是-A";
        obj.list = [
          { label: '菌液',value: '是-A' },
          { label: '平板', value: '是-C' },
          { label: '菌液/平板', value: '是-A/C' },
        ];
        obj.tips = `注：该样品经过${appraisalRollingRingFlag?'PCA':'扩增'}处理，无质粒，只能返还菌液`;
      }
      return obj
  }
  switch (demo.type) { 
    case 'B':
      obj.defaultValue = "是-B";
      obj.list = [
        { label: '质粒',value: '是-B' },
      ];
      obj.tips = "";
      return obj
  }
  switch (demo.type) { 
    case 'D':
    case 'E':  
      obj.defaultValue = "是-PCR";
      obj.list = [
        { label: 'PCR',value: '是-PCR' },
      ];
      obj.tips = "";
      return obj
  }
  switch (demo.type) {
    case 'F':
      if (!appraisalRollingRingFlag && !appraisalAmplificationFlag) {
        obj.defaultValue = "是-A";
        obj.list = [
          { label: '菌液',value: '是-A' },
          { label: '质粒',value: '是-B' },
          { label: '菌液/质粒', value: '是-A/B' },
        ];;
        obj.tips = "";
      }
      if (!appraisalRollingRingFlag && appraisalAmplificationFlag) {
        obj.defaultValue = "是-A";
        obj.list = [
          { label: '菌液',value: '是-A' },
        ];;
        obj.tips = `注：该样品经过扩增处理，无质粒，只能返还菌液`;
      }
      return obj
  }
}


// WEBPACK FOOTER //
// ./src/views/user/contants.js